import styled from 'styled-components';

// @source
import { theme } from '../../styles';

export const LoginScope = styled.div`
  width: 100%;
  height: auto;
  min-height: 100%;
  padding: 3.1rem 1rem 1rem 1rem;
  background-color: ${theme.primary};
  box-sizing: border-box;

  @media (max-width: 768px) {
    & {
      padding-top: 2rem;
    }
  }
`;

export const Section = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
`;

export const Logo = styled.div`
  text-align: center;
  padding-bottom: 3.1rem;

  @media (max-width: 768px) {
    & {
      padding-bottom: 1.5rem;
      svg {
        width: 160px;
      }
    }
  }
`;

export const Title = styled.div`
  color: #DEEBFF;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 400;

  @media (max-width: 768px) {
    & {
      font-size: 1.2rem;
    }
  }
`;

export const Box = styled.div`
  background: #FFFFFF;
  border-radius: 3px;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  color: #172B4D;
  padding: 3rem;
  margin-top: 3.1rem;

  .sc-bdVaJa {
    min-height: auto;
  }

  .sc-gzVnrw {
    font-size: 1.05rem;
  }

  @media (max-width: 768px) {
    & {
      padding: 2rem;
    }
  }
`;

export const Row = styled.div`
  margin-top: 1.5rem;
`;
